import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { API_URL } from '../config';

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // Get the session ID from URL parameters
        const params = new URLSearchParams(location.search);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session ID found');
        }

        // Verify the payment with your backend
        await axios.post(
          `${API_URL}/verify-payment`,
          { sessionId },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        // Redirect to profile page after short delay
        setTimeout(() => {
          navigate('/profile', { replace: true });
        }, 1500);

      } catch (err) {
        console.error('Payment verification failed:', err);
        setError('Failed to verify payment. Please contact support.');
      }
    };

    verifyPayment();
  }, [navigate, location, token]);

  if (error) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <CircularProgress size={60} />
        <Typography variant="h5">
          Processing your subscription...
        </Typography>
        <Typography color="text.secondary">
          You will be redirected to your profile page shortly.
        </Typography>
      </Box>
    </Container>
  );
}

export default Success; 